import React, {useEffect} from 'react'
import {isEmpty} from 'ramda'
import {makeStyles} from '@material-ui/core/styles'
import {Box, CssBaseline, Typography} from '@material-ui/core'
import {connect} from 'react-redux'
import CircularProgress from '@material-ui/core/CircularProgress'
import DepartmentUsersTable from './DepartmentUsers/DepartmentUsersTable'
import {dataActions} from '../../../actions'
import * as R from 'ramda'

// Images
import selectEvent from '../../../images/selectEvent.svg'

// using hook API
const useStyles = makeStyles(theme => ({
    root: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        height: '80vh',
        marginTop: '15px',
    },
    container: {
        display: 'flex',
        flexDirection: 'column',
        width: '-webkit-fill-available',
    },
    emptycontainer: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        minWidth: '380px',
        maxWidth: '435px',
        [theme.breakpoints.down('sm')]: {
            minWidth: '300px',
            maxWidth: '90%',
        },
    },
    titleBox: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        marginBottom: '15px',
    },
    toolBox: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
    },

    buttonlabel: {
        margin: '-10px 5px 0 0',
    },
    filterlabel: {
        marginTop: '-5px',
    },
    searchBox: {
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        border: '1px solid',
        borderColor: theme.palette.grey.medium,
        borderRadius: theme.shape.borderRadius,
        margin: '0 0 0 5px',
        height: '40px',
    },
    searchInput: {
        flex: 1,
        width: '150px',
        margin: '0 10px',
    },
    clearButton: {
        padding: 8,
        color: theme.palette.grey.medium,
    },
}))

const DepartmentUsers = props => {
    const classes = useStyles()

    const {
        token,
        manageroledept,
        departmentusers,
        addingDepartmentUsers,
        deletingDepartmentUsers,
        fetchingDepartmentUsers,
        addDepartmentUsers,
        getDepartmentUsers,
        deleteDepartmentUsers,
    } = props

    useEffect(() => {
        if (!R.isEmpty(manageroledept))
            getDepartmentUsers({token, department: manageroledept})
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [manageroledept])

    return (
        <>
            <CssBaseline />
            <div className={classes.root}>
                {addingDepartmentUsers ||
                deletingDepartmentUsers ||
                fetchingDepartmentUsers ? (
                    <Box
                        className={classes.container}
                        style={{alignItems: 'center', justifyContent: 'center'}}
                    >
                        <CircularProgress
                            style={{
                                color: '#00853e',
                            }}
                            thickness={3}
                        />
                    </Box>
                ) : (
                    <>
                        {isEmpty(manageroledept) ? (
                            <Box className={classes.emptycontainer}>
                                <img src={selectEvent} alt="select event" />
                                <Typography align="center" variant="h5">
                                    Select a Department
                                </Typography>
                                <Typography align="center" variant="body1">
                                    Click any department on the left to
                                </Typography>
                                <Typography align="center" variant="body1">
                                    view department roles.
                                </Typography>
                            </Box>
                        ) : (
                            <Box className={classes.container}>
                                <DepartmentUsersTable
                                    department={manageroledept}
                                    departmentusers={[...departmentusers]}
                                    addDepartmentUsers={addDepartmentUsers}
                                    deleteDepartmentUsers={
                                        deleteDepartmentUsers
                                    }
                                    token={token}
                                />
                            </Box>
                        )}
                    </>
                )}
            </div>
        </>
    )
}

function mapStateToProps(state) {
    return {
        token: state.authentication.token,
        manageroledept: state.departmentsdata.manageroledept,
        departmentusers: state.departmentusersdata.departmentuserslist,
        deletingDepartmentUsers:
            state.departmentusersdata.deletingDepartmentUsers,
        fetchingDepartmentUsers:
            state.departmentusersdata.fetchingDepartmentUsers,
        addingDepartmentUsers: state.departmentusersdata.addingDepartmentUsers,
    }
}

const mapDispatchToProps = {
    addDepartmentUsers: payload =>
        dataActions.departmentusersAddRequest(payload),
    getDepartmentUsers: payload =>
        dataActions.departmentusersGetRequest(payload),
    deleteDepartmentUsers: (token, payload) =>
        dataActions.departmentusersDeleteRequest(token, payload),
}

export default connect(mapStateToProps, mapDispatchToProps)(DepartmentUsers)
